<script lang="ts">
  import Details from "./components/Details.svelte";
  import Footer from "./components/Footer.svelte";
  import RateTest from "./components/RateTest.svelte";
  import TaxCheck from "./components/TaxCheck.svelte";
  import { sectionLabels } from "./lang";
  import { getDatasets } from "./lib/data";

  export let dataPath: string;
  export let postalCodesPath: string;

  const dataRequest = getDatasets({ dataPath, postalCodesPath });
</script>

<div class="App u-space-b-2">
  <Details summary={sectionLabels.taxCheck}>
    {#await dataRequest}
      <p>Daten werden geladen…</p>
    {:then datasets}
      <TaxCheck {datasets} />
    {:catch error}
      <p>Leider konnten die Daten nicht geladen werden.</p>
      <p><small><strong>Fehlermeldung:</strong> {error}</small></p>
    {/await}
  </Details>

  <Details summary={sectionLabels.rateTest}>
    <RateTest />
  </Details>

  <Footer />
</div>

<style>
  .App {
    font-size: var(--size-15);
  }
</style>
